import React from "react";

import { base } from "./Container.styles";


interface ContainerProps {
  as?: React.ElementType | string;
  fluid?: boolean;
  style?: React.CSSProperties;
  children: React.ReactNode;
}

export default function Container({
  as = "div",
  fluid,
  children,
  style,
  ...otherProps
}: ContainerProps) {

  const Tag = as;

  return (
    <Tag
      css={[
        base,
        fluid && {},
        style
      ]}
      {...otherProps}>

      {children}

    </Tag>
  );
}
